import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomOutlinedInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
import { FormControlLabel, Checkbox } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
const useStyles = makeStyles(customInputStyle);

const days = [
  { id: "1", name: "Monday" },
  { id: "2", name: "Tuesday" },
  { id: "3", name: "Wednesday" },
  { id: "4", name: "Thursday" },
  { id: "5", name: "Friday" },
  { id: "6", name: "Saturday" },
  { id: "7", name: "Sunday" },
];

export default function Setup({
  form,
  handleChange,
  timezones = [],
  timeselect1 = null,
  timeselect2 = null,
  buttonsSave,
}) {
  const classes = useStyles();
  return (
    <GridContainer xs={12} sm={12} md={8}>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.is_active || false}
              onChange={handleChange}
              name="is_active"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Active"
        />
      </GridItem>
      <GridItem xs={12} sm={6}></GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Agency start date"
          inputProps={{
            name: "effectivedate",
            value: form.effectivedate || "",
            onChange: handleChange,
            type: "date",
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Agency termination date"
          inputProps={{
            name: "expirationdate",
            value: form.expirationdate || "",
            onChange: handleChange,
            type: "date",
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      {/* Horario de operación */}
      <GridItem xs={12}>
        <strong>Hours of Operation</strong>
      </GridItem>
      <GridItem xs={12} sm={3}></GridItem>
      <GridItem xs={12} sm={2}>
        <CustomSelect
          labelText="Day Start"
          menuItems={[
            { value: "", label: "-- select --" },
            ...days.map((d) => ({ value: d.id, label: d.name })),
          ]}
          value={form.day_start || ""}
          name="day_start"
          onChange={handleChange}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={1} style={{ textAlign: "center", paddingTop: 30 }}>
        <span>-</span>
      </GridItem>
      <GridItem xs={12} sm={2}>
        <CustomSelect
          labelText="Day End"
          menuItems={[
            { value: "", label: "-- select --" },
            ...days.map((d) => ({ value: d.id, label: d.name })),
          ]}
          value={form.day_end || ""}
          name="day_end"
          onChange={handleChange}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={4}></GridItem>
      {/* Horas */}
      <GridItem xs={12} sm={3}></GridItem>
      <GridItem xs={12} sm={2}>
        {timeselect1 ? (
          React.cloneElement(timeselect1, {
            className: classes.colorCheck,
          })
        ) : (
          <CustomInput
            labelText="Hour Start"
            inputProps={{
              name: "hours_opp1",
              value: form.hours_opp1 || "",
              onChange: handleChange,
              type: "time",
            }}
            formControlProps={{ fullWidth: true }}
          />
        )}
      </GridItem>
      <GridItem xs={12} sm={1} style={{ textAlign: "center", paddingTop: 30 }}>
        <span>-</span>
      </GridItem>
      <GridItem xs={12} sm={2}>
        {timeselect2 ? (
          React.cloneElement(timeselect2, {
            className: classes.colorCheck,
          })
        ) : (
          <CustomInput
            labelText="Hour End"
            inputProps={{
              name: "hours_opp2",
              value: form.hours_opp2 || "",
              onChange: handleChange,
              type: "time",
            }}
            formControlProps={{ fullWidth: true }}
          />
        )}
      </GridItem>
      <GridItem xs={12} sm={4}></GridItem>
      {/* Notas */}
      <GridItem xs={12} sm={3}></GridItem>
      <GridItem xs={12} sm={1} style={{ paddingTop: 30 }}>
        <span>Notes</span>
      </GridItem>
      <GridItem xs={12} sm={4}>
        <CustomInput
          labelText=""
          inputProps={{
            name: "notes_operations",
            value: form.notes_operations || "",
            onChange: handleChange,
            multiline: true,
            rows: 2,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      {/* Timezone */}
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Default Time Zone"
          menuItems={timezones.map((tz) => ({
            value: tz.value,
            label: tz.label,
          }))}
          value={form.time_zone || ""}
          name="time_zone"
          onChange={handleChange}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      {/* Comentarios */}
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Comments"
          inputProps={{
            name: "comments",
            value: form.comments || "",
            onChange: handleChange,
            multiline: true,
            rows: 2,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      {buttonsSave()}
    </GridContainer>
  );
}
